$(document).ready(function(){
    $('.faq-question').click(function(){
        var faqId = $(this).data('id');
        $('.faq-question').removeClass('active');
        $(this).addClass('active');
        $('.faq-content').fadeOut();
        $(`#${faqId}`).fadeIn();
    });
})

/**
 * Page bundle bindings
 */

$(document).ready( function () {
    // We only care bundle pages.
    if ($('.page-bundle').length < 1 ) return;

    // The image container rules the entire page size.
    $(window).on('load resize', function () {
        var height = $('.page-bundle__images').outerHeight();
        if(!height) return;
        $('.page-bundle__container').css( 'height', height );
    });

    $('.page-bundle__product__options__value').on('click', function (event) {
        event.preventDefault();

        // if the input is disabled we don't do anything.
        if ( $(this).hasClass('disabled') ) return;

        $(this).addClass('selected')
            .siblings(':not(.disabled)').removeClass('selected');

        var $product = $(this).closest('.page-bundle__product');

        var variant = selectVariant( $product );

        // Setting the variant image
        if ( variant ) {
            var order = $product.data('order');
            selectVariantImage( variant, order );
        }

        if ( $(this).closest('.page-bundle__product__options').data('order') == 1 ) {
            disableUnavailable( $product );
        }

        // To set the color name next to the label.
        if( $(this).hasClass('page-bundle__product__options__value--color') ) {
            $(this).closest('.page-bundle__product__options').find('label .color')
                .text( $(this).data('option') );
        }
    });


    $('.page-bundle__button--add').on('click', function (event) {
        event.preventDefault();
        var bundleId = (new Date()).getTime();
        var items = [];

        // Creating the array of items to add to cart.
        $('.page-bundle__product').each( function (key, value) {
            items.push({
                id: $(this).data('variant-id'),
                quantity: 1,
                properties: {
                    _bundle_id: bundleId,
                    _bundle_line: key + 1,
                    _bundle_price: parseFloat($(this).data('price')) * 100,
                    _bundle_items: parseInt($('.page-bundle').data('bundle-items')),
                    bundle: $('.page-bundle').data('bundle-title')
                }
            });
        });

        // Adding items to cart.
        $.post('/cart/add.js', { items: items }, function ( cart ) {
            var attributes = {};
            attributes['_items_bundle_' + bundleId ] = items.length;
            $.post('/cart/update.js', { attributes: attributes }, function (cart) {
                window.checkGiftsStatus(cart);
                window.checkGiftsTiers();
                console.log('sending added');
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    bubbles: true
                }));
            }, 'json');
        }, 'json');
    });

    // Let's start by disabling all unavailable options.
    $('.page-bundle__product').each( function () {
        disableUnavailable( $(this) );
        var v = selectVariant( $(this) );
        selectVariantImage( v, $(this).data('order') );
    });
});


/**
 * Selects a variant for a product, based on the options selected
 * for that product.
 *
 * @param $product jQuery product object.
 */
function selectVariant ($product) {

    var variant = null;
    var json = $product.data('json');

    // Pulling the selected properties from the DOM.
    var options = $product.find('.page-bundle__product__options__value.selected')
        .map( function ( option ) {
            return $(this).data('option');
        });

    // Finding the variant in the json object.
    variant = json.variants.filter(function (v) {
        var matches = true;
        options.each( function (key, option) {
            if ( option != v['option' + (key + 1)]) {
                matches = false;
            }
        });

        return matches;
    })[0];

    // If the variant is not set, we just return null, and we don't change it.
    if ( typeof variant === 'undefined' ) return null;

    $product.data('variant-id', variant.id );
    return variant;
}


/**
 * Applies the variant image to the image belonging to order.
 *
 * @param variant a Shopify variant object.
 * @param order int belonging to the Order where the image should be applied.
 */
function selectVariantImage(variant, order ) {
    var image = variant.featured_image.src.replace(/\.(jpe?g|gif|png)/, '_800x.$1');
    var $slot = $('.page-bundle__image[data-slot='+ order +'] img')
        .attr('src', image);
}


/**
 * This function disables unavailable variants from selection.
 *
 * @param $product the jQuery object belonging to a product.
 */
function disableUnavailable( $product ) {
    var json = $product.data('json');

    var totalOptions = $product.find('.page-bundle__product__options').length;

    // Let's get our selections first.
    var options = $product.find('.page-bundle__product__options__value.selected')
        .map( function () {
            return $(this).data('option');
        });

    /** Disable Option Color */
    $product.find('.page-bundle__product__options__values').eq(0)
        .find('.page-bundle__product__options__value').each( function () {
        var value = $(this);
        var variants = json.variants.filter( function ( v ) {
            return v.option1 == value.data('option') && options[1] === undefined;
        });
        if(variants.length > 0){
            var available = false;
            variants.forEach( function (v) {
                if ( v.available ) {
                    available = true;
                    return false;
                }
            });
            value.toggleClass('disabled', !available );
        }
    });

    /** Disable Option Sizes */
    $product.find('.page-bundle__product__options__values').eq(1)
        .find('.page-bundle__product__options__value').each( function () {
        var value = $(this);

        var variants = json.variants.filter( function ( v ) {
            return v.option1 == options[0] && v.option2 == value.data('option');
        });
        var available = false;
        variants.forEach( function (v) {
            if ( v.available ) {
                available = true;
                return false;
            }
        });
        value.toggleClass('disabled', !available );
    });

    $product.find('.page-bundle__product__options__values').eq(1)
        .find('.selected.disabled').each( function () {

        $(this).removeClass('selected');
        $(this).siblings(':not(.disabled)')
            .eq(0).click();
    });
}


/**
 * Removing inconsistent bundles.
 */
(function($) {

    window.removeInconsistentBundles = function( _callback ) {
        $.get('/cart.json', function ( cart ) {
            var bundleTotals = {};
            var bundleCounts = {};
            var toDelete = [];

            cart.items.forEach( function (item) {
                if ( item.properties && typeof item.properties._bundle_id !== 'undefined' ) {
                    var id = item.properties._bundle_id;

                    // We get the totals count.
                    if ( typeof bundleTotals[id] === 'undefined' ) {
                        bundleTotals[id] = parseInt(item.properties._bundle_items);
                    }

                    // We get the actual count now.
                    if ( typeof bundleCounts[id] === 'undefined' ) {
                        bundleCounts[id] = 1;
                    }  else {
                        bundleCounts[id]++;
                    }
                }
            });

            // Here we deal with inconsistences. if we find an inconsistence,
            // then we just remove the whole bundle.
            Object.keys( bundleTotals ).forEach( function (key) {
                if ( bundleTotals[key] != bundleCounts[key] ) toDelete.push( key );
            });

            if ( toDelete.length < 1 && typeof _callback === 'function' ) {
                _callback( false );
                return;
            }

            // Now we will get all bundles to delete, and we will do it in a
            // way that we can do it in an atomic transaction.
            var quantities = [];
            cart.items.forEach( function (item) {
                if ( item.properties && typeof item.properties._bundle_id !== 'undefined' ) {
                    var id = item.properties._bundle_id;
                    ( toDelete.indexOf(id) > -1 ) ? quantities.push( 0 ) : quantities.push ( item.quantity );
                }
            });

            $.post('/cart/update.js', { updates: quantities }, function ( response ) {
                if ( typeof _callback === 'function') _callback( true );
            }, 'json' );
        }, 'json');
    }

    removeInconsistentBundles( function ( removed ) {
        if ( removed ) {
            if ( $('body').hasClass('template-cart')) {
                window.location.reload();
            } else {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    bubbles: true
                }));
            }
        }
    });

    $(document).on('click', '.collection-sticker .grid-product', function(e){
        e.preventDefault();
        const productId = $(this).find('.quick-product__btn').data('product-id');
        $('html').addClass('modal-open');
        $('body').addClass('modal-open');
        $(`.modal--quick-shop[data-product-id="${ productId }"]`).addClass('modal--is-active');
        $(`.modal--quick-shop[data-product-id="${ productId }"]`).attr('tabindex', '-1');
        $(".needsclick").addClass("hide");
    });

    $(document).on('click', '.js-modal-close', function(e){
        $('html').removeClass('modal-open');
        $('body').removeClass('modal-open');
        $('.modal--quick-shop').removeClass('modal--is-active');
        $('.modal--quick-shop').removeAttr('tabindex');
        $(".needsclick").removeClass("hide");
    })

}(jQuery));